exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Judge-module__wrapper___2IZhk{display:grid;grid-template-columns:1fr;gap:1.5rem}@media screen and (min-width:525px){.Judge-module__wrapper___2IZhk{grid-template-columns:repeat(auto-fill,minmax(400px,1fr))}}.Judge-module__secondary-title___3foe6{margin-top:2rem;margin-bottom:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Judge-module__wrapper___2IZhk",
	"secondary-title": "Judge-module__secondary-title___3foe6"
};